import React from 'react';
import Api from "util/Api";
import AddEditLocation from "../../../partial/AddEditLocation";


const EditLocation = (props) => {
    if(!props.formValues) return null;

    const {formValues, modalOpen, setModalOpen, auth, getLocationInfo} = props;
    const {id:name, timezone, isHomeCare} = formValues

    const editLocation = async (data) => {
        const {org: facilityId, timezone, type: isHomeCare} = data;

        const requestData =  await Api.withAuth(props.auth).updateFacility({
            orgId: props.auth.currentUser.defaultOrg,
            facilityId,
            timezone,
            isHomeCare
        });

        await getLocationInfo()

        return requestData;
    }

    return (
        <AddEditLocation
            auth={auth}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            sendRequest={editLocation}
            modalTitle='Edit Location'
            formValues={{
                org: name,
                timezone,
                type: isHomeCare.toString()
            }}
            disabledFields={['org']}
            requestSuccessMessage={'Location was successfully updated'}
            requestErrorMessage={'Something went wrong while updating location, check data and try again'}
            shouldResetForm={false}
        />
    );
};

export default EditLocation;